var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team-logo",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"team-logo__content",class:{
      'team-logo--loading': _vm.loading,
      'team-logo--loaded': _vm.isLoaded,
      'team-logo--broken': _vm.isBroken,
      'team-logo--circle': _vm.type === 'circle',
    }},[(_vm.currentUrl && !_vm.isBroken)?_c('img',{staticClass:"team-logo__image",attrs:{"loading":"lazy","src":_vm._f("resizeImage")(_vm._f("isURL")(_vm.currentUrl),240)},on:{"error":function($event){_vm.isBroken = true},"load":function($event){_vm.isLoaded = true}}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }